import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import * as React from 'react';
import { Tab as MuiTab } from '@material-ui/core';

var Tab = function Tab(_ref) {
  var e2e = _ref.e2e,
      args = _objectWithoutProperties(_ref, ["e2e"]);

  return /*#__PURE__*/React.createElement(MuiTab, _extends({}, e2e && {
    'data-e2e': e2e
  }, args));
};

Tab.displayName = 'Tab';
export default Tab;

try {
  Tab.__docgenInfo = {
    description: '',
    displayName: 'Tab',
    methods: [],
    props: {
      'aria-controls': {
        defaultValue: null,
        description: "(Accessibility) ID of element that displays this tab's contents.\n" + 'Ensure this element the role attribute set: `[role="tabpanel"]` .',
        name: 'aria-controls',
        required: true,
        type: {
          name: 'string'
        }
      },
      id: {
        defaultValue: null,
        description: "(Accessibility) This value should be supplied the tab content's\n" + 'element as aria-labelledby="id".',
        name: 'id',
        required: true,
        type: {
          name: 'string'
        }
      },
      component: {
        defaultValue: null,
        description: '',
        name: 'component',
        required: false,
        type: {
          name: 'string'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'If `true`, the base button will be disabled.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      onChange: {
        defaultValue: null,
        description: '',
        name: 'onChange',
        required: false,
        type: {
          name: '((event: ChangeEvent<{ checked: boolean; }>, value: any) => void) & FormEventHandler<HTMLDivElement>'
        }
      },
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      value: {
        defaultValue: null,
        description: '',
        name: 'value',
        required: false,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map